(function() {
    "use strict";

    angular.module("sempraWebapp").component("expensesTransactions", {
        templateUrl: "app/transactions/expenses/expensesTransactions.html",
        controller: expensesTransactionsController,
        bindings: {
            email: "<"
        },
        controllerAs: "vm"
    });

    function expensesTransactionsController(transactionsActions, $translate, $timeout) {
        var vm = this;

        vm.$onInit = function() {
            refreshExpenses();
        };

        vm.$onChanges = function() {
            $timeout(function() {
                refreshExpenses();
            }, 750);
        };

        // DEFAULT DATE
        var currentYear = new Date().getFullYear();
        vm.expensesFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        vm.expensesTo = new Date();

        // GRID CONFIIG
        vm.expensesTransactionOrderBy = "companyName";
        vm.expensesTransactionOrder = "desc";
        vm.expensesTransactionPage = 1;
        vm.expensesTransactionTotal = 0;
        vm.expensesTransactionPageSize = 10;
        vm.expensesTransactionPageOptions = [10, 20];
        vm.selectedexpensesTransaction = [];
        vm.pagerTranslations = {
            page: $translate.instant("GRID_PAGER_PAGE"),
            rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
            of: $translate.instant("GRID_PAGER_PAGE_OF")
        };

        vm.sortChanged = function(order) {
            var orderQuery = getOrderObject(order);
            vm.expensesTransactionOrderBy = orderQuery.orderBy;
            vm.expensesTransactionOrder = orderQuery.order;
            refreshExpenses();
        };

        vm.pageChanged = function(page, limit) {
            vm.expensesTransactionPage = page;
            vm.expensesTransactionPageSize = limit;
            vm.sortChanged(vm.expensesTransactionOrderBy);
        };

        vm.search = function() {
            vm.expensesTransactionPage = 1;
            refreshExpenses();
        };

        function refreshExpenses() {
            var encodeEmail = encodeURIComponent(vm.email);
            vm.promise = transactionsActions
                .getTransactionsExpenses(
                    encodeEmail,
                    vm.expensesFrom.getTime(),
                    vm.expensesTo.getTime(),
                    vm.expensesTransactionPage - 1,
                    vm.expensesTransactionPageSize,
                    vm.expensesTransactionOrderBy,
                    vm.expensesTransactionOrder
                )
                .then(function(data) {
                    vm.expenses = (data.content.length === 0) ? [{companyName: $translate.instant("NOTHING_TO_DISPLAY")}] : data.content;
                    vm.expensesTransactionTotal = data.totalElements;
                });
        }

        function getOrderObject(order) {
            var result = {
                order: "asc",
                orderBy: order
            };

            if (order.indexOf("-") > -1) {
                result.order = "desc";
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();
